import { ContentOption } from '../../common/StateSpecification';

const IACParagraphOptions = {
  Default: `
  <p class="margin-top-10">The Interest Adjusted Cost Comparison Indices provide two means of comparing the relative cost of similar plans of insurance issued by the same company or by different companies. A low index number represents a lower cost than a higher one. These indices reflect the time value of money by applying a 5% interest factor to policy premiums, dividends, and for the surrender cost index, the 10 and 20 year cash values. The dividends used in calculating these indices are based on the illustrated dividend schedule and are neither guarantees nor estimates of future dividends.<br>
  The indices do not consider: (1) the value of the services of an agent or company; (2) the relative strength and reputation of the Company and its actual dividend performance; or (3) differences in the policy provisions.<br>
  This illustration does not recognize the time value of money and should not be used to compare policy costs.</p>
  </div>
  `,
  Alternative: `
  <p class="margin-top-10">The Interest Adjusted Cost Comparison Indices provide two means of comparing the relative cost of similar plans of insurance issued by the same company or by different companies. A low index number represents a lower cost than a higher one. These indices reflect the time value of money by applying a 5% interest factor to policy premiums and for the surrender cost index, the 10 and 20 year cash values.<br>
  The indices do not consider: (1) the value of the services of an agent or company; (2) the relative strength and reputation of the Company; or (3) differences in the policy provisions.<br>
  This illustration does not recognize the time value of money and should not be used to compare policy costs.</p>
  </div>
  `,
  TX: `
  <p class="margin-top-10">
    The Interest Adjusted Index provides one means of comparing the relative cost of similar plans of insurance issued by the same company or by different companies. A low index number represents a lower cost than a higher one. This index considers how much an insured should pay in premiums and how much he would get back in cash value and dividends if he should surrender the policy after 5, 10 or 20 years. This index also considers when premiums, dividends, and 5, 10 or 20 year cash values would be paid by using a 5% interest factor.
  </p>
  <p>
    The dividends used in calculating this index are based on the illustrated dividend schedule, are not guarantees nor estimates of future dividends, are subject to annual change and are dependent upon the investment earnings, the mortality experience and expense experience of the insurer. Policy dividends represent a refund or return of premium paid.
  </p>
  <p>
    The Interest Adjusted Index does not consider: (1) the value of the services of an agent or company; (2) the relative strength and reputation of the Company and its actual dividend performance; or (3) small differences in policy provisions. This index does not necessarily define true cost, but provides a means of comparison.
  </p>
  <p>
    This illustration does not recognize the time value of money and should not be used to compare policy costs.
  </p>
  </div>
  `,
  AR: `
  <p class="margin-top-10">
    The Interest Adjusted Cost Comparison Index provides one means of comparing the relative cost of similar plans of insurance issued by the same company or by different companies. A low index number represents a lower cost than a higher one. This index considers how much an insured should pay in premiums and how much he would get back in cash value and dividends if he should surrender the policy after 5, 10 or 20 years. This index also considers when premiums, dividends, and 5, 10 or 20 year cash values would be paid by using a 4% interest factor.
  </p>
  <p>
    The dividends used in calculating this index are based on the illustrated dividend schedule and are neither guarantees nor estimates of future dividends, are subject to annual change and are dependent upon the investment earnings, the mortality experience and expense experience of the insurer. Policy dividends represent a refund or return of premium paid. Participating policies can be compared with non-participating policies only if it is kept in mind that the Interest Adjusted Cost Comparison Index for participating policies involves dividend projections and therefore is not guaranteed.
  </p>
  <p>
    The Interest Adjusted Index does not take into account, among other things: (1) the value of the services of an agent or company; (2) the relative strength and reputation of the Company; and/or (3) small differences in policy provisions. This index does not necessarily define true cost, but provides a means of comparison.
  </p>
  <p>
    This illustration does not recognize the time value of money and should not be used to compare policy costs.
  </div>
  `,
  PA: `
  <p class="margin-top-10">
    The Surrender Comparison Index was designed to measure the relative cost of life insurance protection and may be useful for comparison of similar policies offered by other companies. Technically, the index shows the relationship between the amounts paid by the insured (the average annual premiums minus any average annual dividend) and the amounts paid by the insurer (the cash value of the policy in the event of surrender over periods of 5, 10 and 20 years) all adjusted for compound interest at the rate of 5% per annum to reflect the timing of payments.
  </p>
  <p>
    The dividends used in calculating these indices are based on the illustrated dividend schedule and are neither guarantees nor estimates of future dividends. In the case of participating life insurance policies, the index may change since future dividends are subject to change, depending on the company's experience. If future dividends increase within the 5, 10 or 20 year period, the index will be lower; if dividends decrease, the index will be higher. Dividends are neither guarantees nor estimates of future results.
  </p>
  <p>
    When comparing similar policies, if all things are equal, the policy with the lower index is generally the lower cost policy and the better buy in the event that the policy was surrendered at the end of the designated period. If death would occur during the designated period, the policy with the lower index would not necessarily be the lower cost policy.
  </p>
  <p>
    The index does not take into account, among other things: (1) the value of the services of an agent or company; (2) the relative strength and reputation of the Company; and (3) small differences in policy provisions. The index does assume that annual premiums are paid, that dividends are taken in cash or applied to premiums, and that no additional benefit provisions are included. Based on the illustrated dividend schedule, dividends are not guaranteed and are subject to change.
  </p>
  <p>
    This illustration does not recognize the time value of money and should not be used to compare policy costs.
  </p>
  </div>
  `,
  CA: `
  <p class="margin-top-10">
    The Surrender Cost Index provides one means of comparing the relative cost of similar plans of insurance issued by the same company or by different companies. A low index number represents a lower cost than a higher one. This index considers how much an insured should pay in premiums and how much he would get back in cash value and dividends if he should surrender the policy after 5, 10 or 20 years. This index also considers when premiums, dividends, and 5, 10 or 20 year cash values would be paid by using a 5% interest factor.
  </p>
  <p>
    The dividends used in calculating this index are based on the illustrated dividend schedule and are neither guarantees nor estimates of future dividends, are subject to annual change and are dependent upon the investment earnings, the mortality experience and expense experience of the insurer. Policy dividends represent a refund or return of premium paid.
  </p>
  <p>
    The Surrender Cost Index does not consider: (1) the value of the services of an agent or company; (2) the relative strength and reputation of the Company and its actual dividend performance; or (3) small differences in policy provisions.
  </p>
  <p>
    This illustration does not recognize the time value of money and should not be used to compare policy costs.
  </p>
  </div>
  `,
};

export const IACmain = {
  styles: `
        .cell-underline { border-bottom: 1px solid #000000; }
        .iac-table-title { text-align: left; vertical-align: top; }
        .iac-table-header { width: 100px; vertical-align: bottom; }
        .iac-table-subheader { vertical-align: bottom; height: 26px; width: 10%; }
    `,
  body: `<div class="break-before nobreak">
    <table class="p-right content full-width" cellpadding="0" cellspacing="0">
      <tr>
        <td class="iac-table-title">
          <h2 class="sub-heading-underline">{{title}}</h2>
        </td>
        <td colspan="3" class="iac-table-header p-center cell-underline">Policy Year</td>
        <tr>
          <tr>
            <td></td>
            {{Col5_subheader}}
            <td class="iac-table-subheader">10</td>
            <td class="iac-table-subheader">20</td>
          </tr>
          <tr>
            <td>{{surrenderCostRowTitle}}</td>
            {{Col5_SCI}}
            <td>{{LI_SCI_PY_10}}</td>
            <td>{{LI_SCI_PY_20}}</td>
          </tr>
          {{NetPaymentCostRow}}
          {{EquivalentLevelRow}}
    </table>
    `,
  supplementalBody: `<div class="nobreak">
  <table class="p-right content full-width" cellpadding="0" cellspacing="0">
    <tr>
      <td class="iac-table-title">
        <h2 class="sub-heading-underline">{{title}}</h2>
      </td>
      <td colspan="3" class="iac-table-header p-center cell-underline">Policy Year</td>
      <tr>
        <tr>
          <td></td>
          {{Col5_subheader}}
          <td class="iac-table-subheader">10</td>
          <td class="iac-table-subheader">20</td>
        </tr>
        <tr>
          <td>{{surrenderCostRowTitle}}</td>
          {{Col5_SCI}}
          <td>{{LI_SCI_PY_10}}</td>
          <td>{{LI_SCI_PY_20}}</td>
        </tr>
        {{NetPaymentCostRow}}
        {{EquivalentLevelRow}}
  </table>`,
  NetPaymentCostRow: `
    <tr>
      <td>{{netPaymentCostRowTitle}}</td>
      {{Col5_NPCI}}
      <td>{{LI_NPCI_PY_10}}</td>
      <td>{{LI_NPCI_PY_20}}</td>
    </tr>
    `,
  EquivalentLevelRow: `
    <tr>
      <td>{{equivalentLevelRowTitle}}</td>
      {{Col5_ELAD5}}
      <td>{{ELAD5_PY_10}}</td>
      <td>{{ELAD5_PY_20}}</td>
    </tr>
    `,
  TextFillOptions: <IACTextFillOptions[]>[
    {
      name: 'Default',
      body: IACParagraphOptions.Default,
      title: 'Interest Adjusted Cost (IAC) Comparison Index',
      surrenderCostRowTitle: 'Life Insurance Surrender Cost Index',
      netPaymentCostRowTitle: 'Life Insurance Net Payment Cost Index',
      equivalentLevelRowTitle: 'Equivalent Level Annual Dividend at {{RATE}}%',
    },
    {
      name: 'IACTextFillAlternative',
      body: IACParagraphOptions.Alternative,
      title: 'Interest Adjusted Cost (IAC) Comparison Index',
      surrenderCostRowTitle: 'Life Insurance Surrender Cost Index',
      netPaymentCostRowTitle: 'Life Insurance Net Payment Cost Index',
      equivalentLevelRowTitle: 'Equivalent Level Annual Dividend at {{RATE}}%',
    },
    {
      name: 'IACTextFillTX',
      body: IACParagraphOptions.TX,
      title: 'Interest Adjusted Cost (IAC) Comparison Index',
      surrenderCostRowTitle: 'Interest Adjusted Index Per $1,000 of Coverage',
      netPaymentCostRowTitle: '',
      equivalentLevelRowTitle: '',
    },
    {
      name: 'IACTextFillAR',
      body: IACParagraphOptions.AR,
      title: 'Interest Adjusted Cost (IAC) Comparison Index',
      surrenderCostRowTitle: 'Interest Adjusted Index Per $1,000 of Face Amount of Basic Insurance',
      netPaymentCostRowTitle: '',
      equivalentLevelRowTitle: 'Equivalent Level Annual Dividend',
    },
    {
      name: 'IACSurrenderComparisonPA',
      body: IACParagraphOptions.PA,
      title: 'Surrender Comparison Index Disclosure',
      surrenderCostRowTitle: 'Surrender Value Index Per $1,000 of Face Amount of Basic Insurance',
      netPaymentCostRowTitle: '',
      equivalentLevelRowTitle: 'Equivalent Level Annual Dividend (Reflected in Above Indicies)',
    },
    {
      name: 'IACSurrenderComparisonCA',
      body: IACParagraphOptions.CA,
      title: 'Life Insurance Surrender Cost Index',
      surrenderCostRowTitle: 'Surrender Cost Index Per $1,000 of Coverage',
      netPaymentCostRowTitle: '',
      equivalentLevelRowTitle: '',
    },
  ],
  Col5YearOptions: {
    Year5: {
      Col5_subheader: `<td class="iac-table-subheader">5</td>`,
      Col5_SCI: `<td>{{LI_SCI_PY_5}}</td>`,
      Col5_NPCI: `<td>{{LI_NPCI_PY_5}}</td>`,
      Col5_ELAD5: `<td>{{ELAD5_PY_5}}</td>`,
    },
    None: {
      Col5_subheader: '',
      Col5_SCI: '',
      Col5_NPCI: '',
      Col5_ELAD5: '',
    },
  },
  AdditionalInfo: {
    Variable: `
      <p>
        This policy has an annually adjustable loan interest rate. A change in the loan rate will affect the net cash value and the net death benefit. Any loans will reduce the net cash value and the net death benefit.
      </p>
      `,
    Fixed: `
      <p>
        This policy has a {{RATE}}% loan interest rate. Loans will affect dividends. Any loans will reduce the net cash value and the net death benefit.
      </p>
      `,
  },
};

export const IACoptions = {
  FLAT_EXTRA: `<p>Based on classified premium category:</p><p class="left-indent">Permanent Flat Extra Premium</p>`,
  HEADER_AND_FULLY_ALLOCATED: `<h2 class="sub-heading-underline">Additional Information About This Illustration</h2><p>The fully allocated expense method is used to allocate overhead expenses for all illustrations.<br>`,

  ANNUAL_NET_OUTLAY: `Annual Net Outlay is based on a tax bracket of {{TAX_BRACKET}}%. <br>`,

  MEC_STATUS: `The first year test for MEC status assumed {{CASH_VALUE_TRANSFER}} would be transferred to the illustrated policy by means of a 1035 Exchange. Cost basis of {{COST_BASIS}} was also assumed to be transferred.<br>`,

  UNSCHEDULED_ALIR_DIVIDEND: `The first year dividend is pro-rated based on the assumption that the 1035 Exchange payment is received {{EXPECTED_ARRIVAL}} after the issue date of the policy. The actual dividend will be based on the day the payment is received. <br>`,

  UNSCHEDULED_ALIR_PAYMENT: `This illustration assumes an unscheduled purchase payment in year 1 of {{TRANSFER_AMOUNT}} under the ALIR. <br>`,
};

export interface IACTextFillOptions extends ContentOption {
  name: string;
  body: string;
  title: string;
  surrenderCostRowTitle: string;
  netPaymentCostRowTitle: string;
  equivalentLevelRowTitle: string;
}
